import axios, {AxiosInstance} from 'axios';

let contentApi: AxiosInstance = axios.create();

export const configureStoryApi = (config: {
  baseURL: string;
  getAuthHeaders?: () => Promise<Record<string, string>> | Record<string, string>;
}) => {
  contentApi = axios.create({baseURL: config.baseURL});

  if (config.getAuthHeaders) {
    contentApi.interceptors.request.use(async req => {
      const headers = await config.getAuthHeaders!();
      Object.assign(req.headers, headers);
      return req;
    });
  }
};

/** Use parent app's axios instance when running inside the monorepo. */
export const setStoryApiClient = (client: AxiosInstance) => {
  contentApi = client;
};

export default contentApi;
